import "@arenza/typefaces-museo-sans";
import PropTypes from "prop-types";
import React from "react";

import "../assets/main.scss";
import '@Development/ui-kit/dist/index.css';
import { Box } from "@material-ui/core";

import iconWhatsapp from '../assets/whatsapp.svg';
import BannerAuto from '../components/BannerAuto';
import LayoutAdaptiveWrapper from "./LayoutAdaptiveWrapper";
import LayoutApplicationContext from "./LayoutApplicationContext";
import LayoutNavigation from "./LayoutNavigation";

Layout.propTypes = {
  children: PropTypes.node,
};
export default function Layout({ children }) {
  return (
    <LayoutAdaptiveWrapper>
      <LayoutApplicationContext>
        <LayoutNavigation>{children}</LayoutNavigation>
      </LayoutApplicationContext>

      <BannerAuto />
    </LayoutAdaptiveWrapper>
  );
}
